import { createFileRoute } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";
import { pageHead } from "@/components/site/seo-copy";
import ContactView from "@/components/cl/views/ContactView";

const API_URL = (import.meta.env["VITE_API_URL"] as string | undefined)?.replace(/\/$/, "") ?? "";

export const Route = createFileRoute("/contact")({
  head: () => pageHead("/contact"),
  component: Contact,
});

function Contact() {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (sending) return;
    // Fields in artifact order: name, email, phone, company, topic, message.
    const f = Array.from(e.currentTarget.elements) as (HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement)[];
    const val = (i: number) => (f[i]?.value ?? "").trim();
    setError("");
    setSending(true);
    try {
      const res = await fetch(`${API_URL}/api/public/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: val(0),
          email: val(1),
          company: val(3),
          message: `${val(4) ? `[${val(4)}]\n` : ""}${val(5)}${val(2) ? `\nPhone: ${val(2)}` : ""}`,
        }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.messages?.error ?? body?.error ?? "Something went wrong. Try again.");
      }
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong. Try again.");
    } finally {
      setSending(false);
    }
  }

  return (
    <>
      <ContactView v={{ sent, notSent: !sent, submit, reset: () => setSent(false) }} />
      {error ? (
        <p role="alert" style={{ position: "fixed", bottom: 16, left: "50%", transform: "translateX(-50%)", background: "#FFFFFF", color: "#B3261E", border: "1px solid #E3E3DE", borderRadius: 8, padding: "12px 18px", fontFamily: "Archivo, system-ui, sans-serif", fontWeight: 700 }}>
          {error}
        </p>
      ) : null}
    </>
  );
}
